import { Box, List, ListItem, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { Done } from "lib/@components/done"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { MovementRow } from "./movement-row"

export function TaskOrderChangesDialog({ originalOrder = [], tailoredOrder = [] }) {
    const movements = buildMovements(originalOrder, tailoredOrder)

    return (
        <DialogBox title="Task Order Changes" Actions={Done}>
            <If truthy={movements.length}>
                <List dense>
                    <ListItem>
                        <ListItemBox fontWeight="bold">
                            <Box flex={1}>Task Title</Box>
                            <Box width={125}>Previous Position</Box>
                        </ListItemBox>
                    </ListItem>
                    <Repeat list={movements} item={<MovementRow />} />
                </List>
                <Else>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                        No task order changes found.
                    </Typography>
                </Else>
            </If>
        </DialogBox>
    )
}

function buildMovements(originalOrder = [], tailoredOrder = []) {
    const originalPositionByTaskId = new Map()
    for (const entry of originalOrder) {
        originalPositionByTaskId.set(entry.taskId, entry.position)
    }

    return tailoredOrder
        .filter((entry) => {
            const originalPosition = originalPositionByTaskId.get(entry.taskId)
            return originalPosition != null && originalPosition !== entry.position
        })
        .map((entry) => ({
            key: entry.taskId,
            title: entry.title ?? entry.taskId,
            position: entry.position,
            previousPosition: originalPositionByTaskId.get(entry.taskId),
        }))
}
